import { observable, action, computed} from 'mobx';
import { useStrict } from 'mobx';
import Transport from './objects/transport';
import {
    date,
    news,
    shipment,
    score,
    cropPlan,
    receptionBunkersStore,
    transportStore,
    storageStore, dcUnitsStore
} from './index';
import settings from './cultureSettings.json'

useStrict(false);
export default class TimeStore{

    @observable timerId;
    @observable currentTime = 0;
    @observable timeSpeed = 1;

    constructor(){
        this.timerId = 0;
        this.currentTime = 0;
        this.timeSpeed = 1;
        this.dayLength=360;
        this.tickCoef=1440/this.dayLength;
    }

    @computed get getTime(){
        let min = (this.currentTime*this.tickCoef) % 60;
        let hour = Math.floor(this.currentTime*this.tickCoef/ 60);
        return (`${hour < 10 ? 0 : ''}${hour}:${min < 10 ? 0 : ''}${min}`)
    }

    @action setTimeSpeed = (item) => {
        this.timeSpeed = item;
    };

    @action setCurrent = (item) => {
        this.currentTime = item;
    };

    @action transportCheck(time, schedule, stack, type){
        while (schedule.length !==0 && time === schedule[schedule.length-1].time){
            // let amount = type === 'truck' ? 20 : 60;
            let transport = schedule.pop();
            let amount = parseFloat((20 * settings[transport.culture].volume).toFixed(1));
            let TransportPos = stack.findIndex((element) =>{
                return(element.moistureLevel === transport.moisture && element.wasteLevel === transport.waste && element.culture === transport.culture)
            });
            if (TransportPos !== -1){
                stack[TransportPos].groupQuantity += (transport.item);
            } else {
                stack.push(
                    new Transport(transport.culture, amount, amount, transport.moisture, transport.waste, transport.item,
                        transport.moisture >= settings[transport.culture].critMoisture ||  transport.waste >= settings[transport.culture].critWaste ? "alert" : '')
                );
            }
            cropPlan.currentWeight[transport.culture]-=amount*transport.item;
            cropPlan.dayPlan[transport.culture]-=amount*transport.item;
            cropPlan.weekPlan[transport.culture]-=amount*transport.item;
            cropPlan.monthPlan[transport.culture]-=amount*transport.item;
            news.addInputMassage(transport,type);
        }
    };

    @action startShipping(){
        shipment.shipmentBunker.forEach((item)=>{
            item.shippingFrom();
        });
        storageStore.silosList.forEach((item)=>{
            item.checkUnit();
        });
        storageStore.hoppersList.forEach((item)=>{
            item.checkUnit();
        });
        receptionBunkersStore.receptionBunker.forEach((item)=>{
            item.checkBunker();
        });
        dcUnitsStore.dryingList.forEach((item)=>{
            item.checkUnit()
        });
        dcUnitsStore.cleaningList.forEach((item)=>{
            item.checkUnit()
        });


        score.checkScore();
    }

    @action startTime(){
        let time = this.currentTime;
           this.timerId = setInterval(()=>{
                   time += 1;
                    this.transportCheck(time, date.scheduleReception.truck, transportStore.receptionTruck, 'truck');
                    this.transportCheck(time, date.scheduleReception.train, transportStore.receptionTrain, 'train');
                    this.startShipping();
                   if (time > this.dayLength) {
                       time = 0;
                       news.setNewDay();
                       date.setCurrentDay();
                   }
                   this.setCurrent(time);
            },(125/(this.timeSpeed === 1 ? this.timeSpeed : this.timeSpeed*2)));
    }

    @action breaker(){
        clearInterval(this.timerId);
    }

}



// WEBPACK FOOTER //
// ./src/shared/stores/time.js